import styled from 'styled-components';
import AppBar from '@material-ui/core/AppBar';
import { IconButton } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/HelpOutline';
import { useAuthContext } from '../../contexts/AuthContext';
import logo from '../../assets/kassim_logo.png';
import { kassimBlue, headerHeight } from '../../style/theme';
import AccountMenu from './AccountMenu';
import HeaderMenu from './HeaderMenu';

export { headerHeight };

const StyledAppBar = styled(AppBar)`
    min-height: 32px;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 24px;
    height: ${headerHeight}px;
    background: white;
    color: ${kassimBlue};
`;

const Section = styled.div`
    height: 100%;
    display: flex;
    align-items: center;

    & img {
        max-height: 100%;
    }
`;

const AppHeader = () => {
    const { auth } = useAuthContext();
    const { helpUrl } = auth;

    return (
        <StyledAppBar position="sticky">
            <Section>
                <img src={logo} alt="Kassim logo" />
            </Section>
            <Section>
                {helpUrl && (
                    <IconButton href={helpUrl} target="help-page" rel="help">
                        <HelpIcon />
                    </IconButton>
                )}
                <HeaderMenu />
                {auth.isAuthenticated && (
                    <AccountMenu label={auth.username || auth.useremail} />
                )}
            </Section>
        </StyledAppBar>
    );
};
export default AppHeader;
